/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fpbcKyXdMTvY59T4C5fjcC
// Component: JzpEJAQTjPX

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  renderPlasmicSlot,
  SingleChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fpbcKyXdMTvY59T4C5fjcC/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../../components/modals/plasmic/plasmic_kit_project_settings/plasmic_plasmic_kit_project_settings.css"; // plasmic-import: fpbcKyXdMTvY59T4C5fjcC/projectcss
import sty from "./PlasmicGitJobStep.module.css"; // plasmic-import: JzpEJAQTjPX/css

import CheckSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__CheckSvg"; // plasmic-import: f0RrtBrXp/icon
import ChevronRightSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronRightSvg"; // plasmic-import: HBGx-zeiX/icon
import WarningTriangleSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__WarningTriangleSvg"; // plasmic-import: S0L-xosWD/icon

createPlasmicElementProxy;

export type PlasmicGitJobStep__VariantMembers = {
  status: "unstarted" | "started" | "failed" | "finished";
};
export type PlasmicGitJobStep__VariantsArgs = {
  status?: SingleChoiceArg<"unstarted" | "started" | "failed" | "finished">;
};
type VariantPropType = keyof PlasmicGitJobStep__VariantsArgs;
export const PlasmicGitJobStep__VariantProps = new Array<VariantPropType>(
  "status"
);

export type PlasmicGitJobStep__ArgsType = { children?: React.ReactNode };
type ArgPropType = keyof PlasmicGitJobStep__ArgsType;
export const PlasmicGitJobStep__ArgProps = new Array<ArgPropType>("children");

export type PlasmicGitJobStep__OverridesType = {
  root?: Flex__<"li">;
  svg?: Flex__<"svg">;
  freeBox?: Flex__<"div">;
};

export interface DefaultGitJobStepProps {
  children?: React.ReactNode;
  status?: SingleChoiceArg<"unstarted" | "started" | "failed" | "finished">;
  className?: string;
}

const $$ = {};

function PlasmicGitJobStep__RenderFunc(props: {
  variants: PlasmicGitJobStep__VariantsArgs;
  args: PlasmicGitJobStep__ArgsType;
  overrides: PlasmicGitJobStep__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <li
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "li",
        "li__fpbcK",
        "root_reset_fpbcKyXdMTvY59T4C5fjcC",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootstatus_started]: hasVariant($state, "status", "started"),
          [sty.rootstatus_unstarted]: hasVariant($state, "status", "unstarted"),
        }
      )}
    >
      <PlasmicIcon__
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        PlasmicIconType={
          hasVariant($state, "status", "finished")
            ? CheckSvgIcon
            : hasVariant($state, "status", "failed")
            ? WarningTriangleSvgIcon
            : ChevronRightSvgIcon
        }
        className={classNames("all", sty.svg, {
          [sty.svgstatus_failed]: hasVariant($state, "status", "failed"),
          [sty.svgstatus_finished]: hasVariant($state, "status", "finished"),
          [sty.svgstatus_started]: hasVariant($state, "status", "started"),
          [sty.svgstatus_unstarted]: hasVariant($state, "status", "unstarted"),
        })}
        role={"img"}
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        {renderPlasmicSlot({
          defaultContents: "Step description",
          value: args.children,
          className: classNames(sty.slotTargetChildren, {
            [sty.slotTargetChildrenstatus_failed]: hasVariant(
              $state,
              "status",
              "failed"
            ),
            [sty.slotTargetChildrenstatus_finished]: hasVariant(
              $state,
              "status",
              "finished"
            ),
            [sty.slotTargetChildrenstatus_started]: hasVariant(
              $state,
              "status",
              "started"
            ),
            [sty.slotTargetChildrenstatus_unstarted]: hasVariant(
              $state,
              "status",
              "unstarted"
            ),
          }),
        })}
      </div>
    </li>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg", "freeBox"],
  svg: ["svg"],
  freeBox: ["freeBox"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "li";
  svg: "svg";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicGitJobStep__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicGitJobStep__VariantsArgs;
    args?: PlasmicGitJobStep__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicGitJobStep__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicGitJobStep__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicGitJobStep__ArgProps,
          internalVariantPropNames: PlasmicGitJobStep__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicGitJobStep__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicGitJobStep";
  } else {
    func.displayName = `PlasmicGitJobStep.${nodeName}`;
  }
  return func;
}

export const PlasmicGitJobStep = Object.assign(
  // Top-level PlasmicGitJobStep renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicGitJobStep
    internalVariantProps: PlasmicGitJobStep__VariantProps,
    internalArgProps: PlasmicGitJobStep__ArgProps,
  }
);

export default PlasmicGitJobStep;
/* prettier-ignore-end */
